var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    ref: "instance",
    staticClass: "h-max"
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };